import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Valentina', 'Camila', 'Lucía', 'Florencia', 'Agustina', 'Martina', 'Sofía', 'Julieta', 'Antonella', 'Micaela', 'Carolina', 'Paula', 'Daniela', 'Romina', 'Mariana', 'Victoria', 'Milagros', 'Rocío', 'Sol', 'Guadalupe'];
const locations = ['Buenos Aires, CABA', 'La Plata, Buenos Aires', 'Mar del Plata, Buenos Aires', 'Bahía Blanca, Buenos Aires', 'Córdoba Capital, Córdoba', 'Río Cuarto, Córdoba', 'Villa María, Córdoba', 'Rosario, Santa Fe', 'Santa Fe Capital, Santa Fe', 'Mendoza Capital, Mendoza', 'San Rafael, Mendoza', 'San Miguel de Tucumán, Tucumán', 'Salta Capital, Salta', 'San Salvador de Jujuy, Jujuy', 'Neuquén Capital, Neuquén', 'San Carlos de Bariloche, Río Negro', 'General Roca, Río Negro', 'Posadas, Misiones', 'Resistencia, Chaco', 'Corrientes Capital, Corrientes', 'Paraná, Entre Ríos', 'Concordia, Entre Ríos', 'Santiago del Estero, Santiago del Estero', 'La Rioja Capital, La Rioja', 'San Juan Capital, San Juan', 'San Luis Capital, San Luis', 'Catamarca, Catamarca', 'Formosa Capital, Formosa', 'Comodoro Rivadavia, Chubut', 'Río Gallegos, Santa Cruz', 'Ushuaia, Tierra del Fuego', 'Viedma, Río Negro', 'Rawson, Chubut', 'San Fernando del Valle, Catamarca'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setCurrentName(randomName);
      setCurrentLocation(randomLocation);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay (10-20s)
    const initialDelay = Math.random() * 10000 + 10000;
    const initialTimer = setTimeout(showPopup, initialDelay);
    // Recurring interval (every 20-35s)
    const interval = setInterval(() => {
      const delay = Math.random() * 15000 + 5000;
      setTimeout(showPopup, delay);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-3 left-3 z-50 animate-slide-in" data-id="element-382">
      <div className="relative bg-black/90 backdrop-blur-xl rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.2)] py-3 pl-4 pr-8 max-w-[290px] border border-[#d4af37]/40 overflow-hidden" data-id="element-383">
        <div className="absolute top-0 left-0 h-full w-1 bg-gradient-to-b from-[#d4af37] to-[#aa8c2c] shadow-[0_0_12px_rgba(212,175,55,0.8)]" data-id="element-384" />
        <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 text-slate-500 hover:text-slate-200 transition-colors" aria-label="Cerrar notificación" data-id="element-385">
          <XIcon className="h-3.5 w-3.5" data-id="element-386" />
        </button>
        <div className="flex items-start gap-2.5" data-id="element-387">
          <div className="bg-[#d4af37]/15 rounded-full p-1 flex-shrink-0 mt-0.5 shadow-[0_0_12px_rgba(212,175,55,0.4)]" data-id="element-388">
            <CheckCircleIcon className="h-4 w-4 text-[#d4af37]" data-id="element-389" />
          </div>
          <div className="min-w-0" data-id="element-390">
            <p className="text-xs font-bold text-white truncate" data-id="element-391">
              {currentName} de {currentLocation}
            </p>
            <p className="text-[11px] text-slate-300 mt-0.5 leading-tight" data-id="element-392">
              Acaba de unirse a{' '}
              <span className="text-[#d4af37] font-bold" data-id="element-393">Trato de Reina</span>{' '}
              👑
            </p>
            <p className="text-[9px] text-slate-500 mt-1 flex items-center gap-1" data-id="element-394">
              <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37] animate-pulse" data-id="element-395" />
              Hace un momento
            </p>
          </div>
        </div>
      </div>
    </div>;
}